export const editSideNavItems = [
  {
    title: "Participation",
    path: "#participation",
    roles: ["admin", "user"],
  },
  {
    title: "Size determination",
    path: "#size-determination",
    roles: ["admin"],
  },
  {
    title: "Overview information",
    path: "#overview-information",
    roles: ["admin", "user"],
  },
  {
    title: "Organization & ownership",
    path: "#organization-ownership",
    roles: ["admin", "user"],
  },
  {
    title: "Certifications",
    path: "#certifications",
    roles: ["admin", "user"],
  },
  {
    title: "NAICS codes",
    path: "#naics-codes",
    roles: ["admin", "user"],
  },
  {
    title: "Service information",
    path: "#service-information",
    roles: ["admin", "user"],
  },
  {
    title: "Export information",
    path: "#export-information",
    roles: ["admin", "user"],
  },
  {
    title: "Performance history",
    path: "#performance-history",
    roles: ["admin", "user"],
  },
];
